import type { PlainWorkflowExecution } from "@/queries/automation-queries";
import type { FC } from "react";
import { Link } from "@/components/flexkit/Link";
import { WorkflowExecutionsCard } from "@/components/automations/AutomationExecutionCard";
import { workflowExecutionsUrl } from "@/utils/automations";
import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { Button } from "@/components/flexkit/Button";
import { IconPlay } from "@/assets/icons/geist/IconPlay";

type WorkflowExecutionsListProps = {
    executions: PlainWorkflowExecution[];
    onRunWorkflow: () => void;
};

export const WorkflowExecutionsList: FC<WorkflowExecutionsListProps> = ({ executions, onRunWorkflow }) => {
    if (executions.length === 0) {
        return (
            <EmptyStateCard
                title="No executions yet"
                description="Run this automation to create a new execution. It will run all defined steps across your configured contexts and report progress as it completes."
                data-testid="workflow-executions-empty-state"
            >
                <Button
                    variant="primary"
                    LeadingIcon={IconPlay}
                    onClick={onRunWorkflow}
                    data-tracking-id="run-workflow-empty-state"
                >
                    Run Automation
                </Button>
            </EmptyStateCard>
        );
    }

    return (
        <div className="flex flex-col gap-2">
            {executions.map((execution) => (
                <Link key={execution.id} to={workflowExecutionsUrl(execution)} className="flex-1">
                    <WorkflowExecutionsCard execution={execution} />
                </Link>
            ))}
        </div>
    );
};
